import { combineReducers } from "redux";
import bet_history from "../features/admin/roulette/bet_history/slice";
import roulette_manual_result from "../features/admin/roulette_manual_result/Slice";

const roulette = combineReducers({
  bet_history: bet_history,
  roulette_manual_result: roulette_manual_result,
});

export default roulette;
